import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getContent } from "@/services/content";
import { MenuItem } from "@/types/settings";
import { useCallback, useEffect, useState } from "react";

interface ContentPageProps {
  data: MenuItem;
}

export default function ContentPage({ data }: ContentPageProps) {
  const [content, setContent] = useState<any[]>();

  const loadData = useCallback(async (collection: string) => {
    const result = await getContent(collection);
    setContent(result);
  }, []);

  useEffect(() => {
    if (!data) return;
    if (data.dataSource === "custom_collection") {
      const collection = data.dataSourceId;
      loadData(collection);
    }
  }, [data, loadData]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {content?.map((item) => (
        <Card key={item._id} className="">
          <CardHeader>
            <CardTitle className="flex items-center gap-3">
              {item.title}
            </CardTitle>
            <img
              src={item.image.original.url}
              alt={item.title}
              className="w-full aspect-[16/9] object-contain object-center rounded-lg bg-gray-10 border shadow"
            />
          </CardHeader>
          <CardContent>
            <div dangerouslySetInnerHTML={{ __html: item.content }} />
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
